// @ts-nocheck

import { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { EmployeeMarker } from "../../components/MapActivities/EmployeeMarker";
import axios from "axios";
import { TowerMarker } from "../../components/MapActivities/TowerMarker";

// Componente para atualizar o centro do mapa
function ChangeMapView({ center }: { center: [number, number] }) {
  const map = useMap();
  useEffect(() => {
    map.setView(center);
  }, [center, map]);
  return null;
}

// Pontos em São Paulo
const locations = {
  start: {
    name: "Sede TLP",
    position: [-23.5489, -46.6388], // Centro de São Paulo
  },
  points: [
    {
      name: "Ponto 1 - Parque Ibirapuera",
      position: [-23.5874, -46.6576],
    },
    {
      name: "Ponto 2 - Estação Luz",
      position: [-23.5345, -46.6346],
    },
    {
      name: "Ponto 3 - Shopping Eldorado",
      position: [-23.5717, -46.697],
    },
  ],
};

export function MapActivities() {
  const [mapCenter, setMapCenter] = useState<[number, number]>(locations.start.position);
  const [dataOnMap, setDataOnMap] = useState([]);

  useEffect(() => {
    const baseUrl = "https://radar.tlpservicos.com.br/api/toa/local-atividade2";
    const fetchData = async () => {
      try {
        const { data } = await axios.get(baseUrl);
        setDataOnMap(data);
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="w-full h-full flex flex-col bg-gray-350 rounded-lg overflow-hidden relative">
      <div className="bg-gray-400 h-6 drag-handle cursor-move flex items-center px-2 rounded-t-md">
        Mapa de Atividades
      </div>

      <div className="flex-1 flex flex-row relative p-4">
        <div className="w-[270px] mt-2 flex flex-col items-center">
          <input className="h-8 rounded-sm" />
        </div>
        <MapContainer
          key="map"
          center={mapCenter}
          zoom={12}
          scrollWheelZoom={true}
          style={{
            height: "calc(100% - 20px)",
            width: "calc(100% - 20px)",
            margin: "10px",
          }}
        >
          <ChangeMapView center={mapCenter} />
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />

          {/* Marcador do ponto inicial */}
          <Marker position={locations.start.position} title={locations.start.name} />

          {/* Marcadores dos pontos de atividade */}
          {/* {locations.points.map((point, index) => (
            <Marker key={index} position={point.position} title={point.name} />
          ))} */}
          {dataOnMap.atividades &&
            dataOnMap.atividades.map((point, index) => (
              <TowerMarker
                key={`stop-${index}`}
                position={[point.atividade_latitude, point.atividade_longitude]}
                // duration="101"
                popupContent={
                  <>
                    Parada
                    <br />
                    Início: OK
                    <br />
                    Fim: OK
                    <br />
                    Duração: 200 minutos
                  </>
                }
              />
            ))}
          {dataOnMap.atividades &&
            dataOnMap.atividades.map(
              (point, index) =>
                point.tecnico_latitude &&
                point.tecnico_longitude && (
                  <EmployeeMarker
                    key={`stop-${index}`}
                    position={[point.tecnico_latitude, point.tecnico_longitude]}
                    // duration="101"
                    popupContent={
                      <>
                        Parada
                        <br />
                        Início: OK
                        <br />
                        Fim: OK
                        <br />
                        Duração: 200 minutos
                      </>
                    }
                  />
                )
            )}
        </MapContainer>
      </div>
    </div>
  );
}
